import navigateToNextOnboardingPageAction from "@actions/navigateToNextOnboardingPageAction"
import onboardingLoader from "@loaders/onboardingLoader"
import BuildingPage from "@pages/onboarding/BuildingPage"
import DistractionsPage from "@pages/onboarding/DistractionsPage"
import DriversPage from "@pages/onboarding/DriversPage"
import EnergyPage from "@pages/onboarding/EnergyPage"
import FeedbackPage from "@pages/onboarding/FeedbackPage"
import GenderPage from "@pages/onboarding/GenderPage"
import GetUpPage from "@pages/onboarding/GetUpPage"
import GladPage from "@pages/onboarding/GladPage"
import GoalsPage from "@pages/onboarding/GoalsPage"
import LifestylePage from "@pages/onboarding/LifestylePage"
import MotivationPage from "@pages/onboarding/MotivationPage"
import ProcrastinationPage from "@pages/onboarding/ProcrastinationPage"
import ReadyPage from "@pages/onboarding/ReadyPage"
import SleepPage from "@pages/onboarding/SleepPage"
import StatementAnxiousPage from "@pages/onboarding/StatementAnxiousPage"
import StatementConcentrationPage from "@pages/onboarding/StatementConcentrationPage"
import StatementRegretPage from "@pages/onboarding/StatementRegretPage"
import StatementTimePage from "@pages/onboarding/StatementTimePage"
import { Navigate, Outlet } from "react-router-dom"
import AdhdPage from "./AdhdPage"
import AwarenessPage from "./AwarenessPage"
import CompanyPage from "./CompanyPage"
import DrainedPage from "./DrainedPage"
import EmotionalConnectionPage from "./EmotionalConnectionPage"
import EnergyTransitionPage from "./EnergyTransitionPage"
import ExercisePage from "./ExercisePage"
import HabitConsistencyPage from "./HabitConsistencyPage"
import OverthinkPage from "./OverthinkPage"
import PhoneTimePage from "./PhoneTimePage"
import PowerfulTransitionPage from "./PowerfulTransitionPage"
import RefocusTimePage from "./RefocusTimePage"
import SelfCarePage from "./SelfCarePage"
import SelfTalkPage from "./SelfTalkPage"
import StressPage from "./StressPage"
import StrugglePage from "./StrugglePage"
import TakingBreaksPage from "./TakingBreaksPage"
import TransitionPage from "./TransitionPage"

const onboardingRoutes = [
  {
    path: "/onboarding",
    element: <Outlet />,
    loader: onboardingLoader,
    children: [
      {
        element: <Navigate to="age" replace />,
        index: true,
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <CompanyPage />,
        path: "company",
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <GenderPage />,
        path: "age",
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <GladPage />,
        path: "glad",
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <DrainedPage />,
        path: "drained",
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <OverthinkPage />,
        path: "overthink",
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <SelfCarePage />,
        path: "self-care",
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <PhoneTimePage />,
        path: "phone-time",
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <AwarenessPage />,
        path: "awareness",
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <StressPage />,
        path: "stress",
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <EmotionalConnectionPage />,
        path: "emotional-connection",
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <StrugglePage />,
        path: "struggle",
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <AdhdPage />,
        path: "adhd",
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <TransitionPage />,
        path: "transition",
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <HabitConsistencyPage />,
        path: "habit-consistency",
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <RefocusTimePage />,
        path: "refocus-time",
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <SleepPage />,
        path: "sleep",
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <GetUpPage />,
        path: "get-up",
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <EnergyPage />,
        path: "energy",
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <EnergyTransitionPage />,
        path: "energy-transition",
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <ExercisePage />,
        path: "exercise",
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <LifestylePage />,
        path: "lifestyle",
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <GoalsPage />,
        path: "goals",
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <MotivationPage />,
        path: "motivation",
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <DistractionsPage />,
        path: "distractions",
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <ProcrastinationPage />,
        path: "procrastination",
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <DriversPage />,
        path: "drivers",
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <BuildingPage />,
        path: "building",
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <SelfTalkPage />,
        path: "self-talk",
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <TakingBreaksPage />,
        path: "taking-breaks",
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <ReadyPage />,
        path: "ready",
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <FeedbackPage />,
        path: "feedback",
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <StatementAnxiousPage />,
        path: "statement-anxious",
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <StatementConcentrationPage />,
        path: "statement-concentration",
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <StatementRegretPage />,
        path: "statement-regret",
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <PowerfulTransitionPage />,
        path: "powerful-transition",
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <StatementTimePage />,
        path: "statement-time",
      },
    ],
  },
]

export default onboardingRoutes
